// init.js
// Start-up side-effect module: App.js does `import './init'` before rendering, which installs the
// tenant and token headers on axios exactly once.
//
// The logic lives in services/apiClient.js (migration plan R-5). This file stays so the existing
// `import './init'` call site and the historical name keep working.
//
// Dev override: opening the app from localhost or a LAN IP used to require editing the commented
// list below. Set REACT_APP_DEV_SUBDOMAIN instead (see .env.1tvet); 'makati' remains the fallback.

import { configureApiClient } from './services/apiClient';

configureApiClient();

export default configureApiClient;
